import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/payperiods');
}
//Get all active
export function allActive(){
    return http().get('/payperiods/active');
}
//Get Single
export function single(id){
    return http().get(`/payperiods/${id}`);
}
//Add one
export function add(data){
    return http().post('/payperiods', data)
}
//Update
export function update(id, data){
    return http().put(`/payperiods/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/payperiods/${id}`);
}
